import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditNewsModal from './EditNewsModal';
import AddNewsModal from './AddNewsModal';
import ViewNewsModal from './ViewNewsModal';
import '../../style/NewsList.css';

const NewsList = () => {
    const [news, setNews] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedNews, setSelectedNews] = useState(null);

    useEffect(() => {
        axios.get('https://api.alertapp.kz/api/v1/news')
            .then(response => setNews(response.data))
            .catch(error => console.error('Ошибка при загрузке новостей:', error));
    }, []);

    const handleEditClick = (newsItem) => {
        console.log("Редактирование новости:", newsItem);
        setSelectedNews(newsItem);
        setIsEditModalOpen(true);
    };

    const handleViewClick = (newsItem) => {
        console.log("Просмотр новости:", newsItem);
        setSelectedNews(newsItem);
        setIsViewModalOpen(true);
    };

    const handleDelete = (id) => {
        console.log("Удаление новости с ID:", id);
        axios.delete(`https://api.alertapp.kz/api/v1/news/${id}`)
            .then(() => {
                setNews(prevNews => prevNews.filter(item => item._id !== id));
            })
            .catch(error => console.error('Ошибка удаления:', error));
    };

    const handleUpdate = (updatedNews) => {
        console.log("Обновление новости:", updatedNews);
        setNews(prevNews => prevNews.map(item => item._id === updatedNews._id ? updatedNews : item));
        setIsEditModalOpen(false);
    };

    const handleAdd = (newNews) => {
        console.log("Добавление новости:", newNews);
        setNews(prevNews => [...prevNews, newNews]);
        setIsAddModalOpen(false);
    };

    return (
        <div className="news-container">
            <table className="news-table">
                <thead>
                <tr>
                    <th>Заголовок</th>
                    <th>Дата</th>
                    <th>Действия</th>
                </tr>
                </thead>
                <tbody>
                {news.map((item) => (
                    <tr key={item._id}>
                        <td>{item.title}</td>
                        <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                        <td>
                            <button onClick={() => handleViewClick(item)}>Детали</button>
                            <button onClick={() => handleEditClick(item)}>Редактировать</button>
                            <button onClick={() => handleDelete(item._id)}>Удалить</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <button className="add-button" onClick={() => setIsAddModalOpen(true)}>Добавить новость</button>

            {isEditModalOpen && (
                <EditNewsModal
                    newsItem={selectedNews}
                    onClose={() => setIsEditModalOpen(false)}
                    onUpdate={handleUpdate}
                />
            )}

            {isViewModalOpen && (
                <ViewNewsModal
                    newsItem={selectedNews}
                    onClose={() => setIsViewModalOpen(false)}
                />
            )}

            {isAddModalOpen && (
                <AddNewsModal
                    onClose={() => setIsAddModalOpen(false)}
                    onAdd={handleAdd}
                />
            )}
        </div>
    );
};

export default NewsList;
